<div class="select-org-dialog">
  @if (loading()) {
    <p class="select-org-hint">{{ 'account.select_org.loading' | transloco }}</p>
  } @else if (!orgList().length) {
    <nz-empty [nzNotFoundContent]="contentTpl">
      <ng-template #contentTpl>
        <p>{{ 'account.select_org.empty_description' | transloco }}</p>
        <p>{{ 'account.select_org.empty_contact' | transloco }}</p>
      </ng-template>
    </nz-empty>
    <p class="region-hint">{{ 'account.select_org.region_hint' | transloco }}</p>
    <div class="region-list">
      @for (region of regionOptions(); track region) {
        <button
          type="button"
          nz-button
          nzType="default"
          class="region-button"
          [class.current-region]="region === currentRegion()"
          [disabled]="region === currentRegion() || regionSwitching()"
          (click)="switchRegion(region)"
        >
          {{ ('shared.regions.' + region) | transloco }}
          @if (region === currentRegion()) {
            <span>({{ 'account.select_org.current_region' | transloco }})</span>
          }
        </button>
      }
    </div>
    @if (required) {
      <button type="button" nz-button nzType="default" class="logout-btn" (click)="logout()">
        {{ 'shell.header.logout' | transloco }}
      </button>
    }
  } @else {
    <div class="list-container">
      @for (org of orgList(); track org?.id) {
        <button
          type="button"
          class="org-button"
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="selectOrg(org)"
        >
          {{ org?.name }}
        </button>
      }
    </div>
  }
</div>
